export const LINK_APP_STORE = "https://apps.apple.com/us/app/metamask-blockchain-wallet/id1438144202";

export const LINK_GOOGLE_PLAY = "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=io.metamask";

/**
 * @name IS_SAFARI
 * @constant
 * @boolean
 * @description Determines if the current browser being used to view the site is Safari.
 */
export const IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

/**
 * @name IS_IOS
 * @constant
 * @description Determines if the current browser is an iOS device
 */
export const IS_IOS = [ 'iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod' ].includes( window.navigator.platform ) || ( navigator.userAgent.includes("Mac") && "ontouchend" in document )